import { Stack } from "@mui/material";

import { Label } from "../../../Label/Label";
import { ModelCardLabelFragment } from "../../models.graphql";

interface ModelCardContentLabelsProps {
  labels: ModelCardLabelFragment[];
  onClickLabel?: (event: React.MouseEvent, labelId: string) => void;
  overflowCount: number;
}

export const ModelCardContentLabels = (props: ModelCardContentLabelsProps) => {
  const { labels, onClickLabel, overflowCount } = props;

  return (
    labels.length > 0 && (
      <Stack direction="row" gap={1}>
        {labels.map((label) => (
          <Label
            key={label.id}
            id={String(label.id)}
            label={label.name}
            onClick={onClickLabel}
          />
        ))}
        {overflowCount > 0 && <Label label={`+${overflowCount}`} />}
      </Stack>
    )
  );
};
